export default () => ({
  tableCell: {
    padding: '12px 16px',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
  },
  tableCellTextEllipsis: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#00000099',
  },
  messagePreview: {
    maxWidth: '300px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'inline-block',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#00000099',
  },
  actionsCell: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  actionButton: {
    textTransform: 'none',
    fontSize: '12px',
    padding: '4px 8px',
  },
});
